import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface UseCompetitorProductPermissionsReturn {
  hasFullAccess: boolean
  isViewOnly: boolean
}

export const useCompetitorProductPermissions = (): UseCompetitorProductPermissionsReturn => {
  const { hasPermissions } = usePermissionManager()

  const hasFullAccess = hasPermissions([PermissionActionType.EQUIVALENT_MAINTENANCE])

  const isViewOnly =
    !hasFullAccess && hasPermissions([PermissionActionType.VENDOR_VIEW, PermissionActionType.VENDOR_MAINTENANCE])

  return {
    hasFullAccess,
    isViewOnly,
  }
}
